<template>
  <span class="bl-text-body-3" v-html="text"></span>
</template>

<script>
export default {
  props: {
    text: {
      type: String | Number,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
span.bl-text-body-3 {
  position: relative;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: calc(5 / 3);
  letter-spacing: 0.5px;
  padding: 0;
  margin: 0;
  color: var(--Slate-10, #1d2939);
}
</style>



// WEBPACK FOOTER //
// src/components/BlTextBody3.vue